module.exports = __webpack_public_path__ + "static/media/1.469d7920.jpg";